var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer } from 'uitk-react-menu';
import { UitkIcon } from 'uitk-react-icons';
import { Viewport, ViewLarge, ViewSmall, ViewMedium, ViewExtraLarge, defaultViewSizes } from '@shared-ui/viewport-context';
import { TripsNavigation } from '@shared-ui/trips-navigation';
import { UitkTertiaryButton, UitkButtonSize } from 'uitk-react-button';
import { UitkText } from 'uitk-react-text';
import { forceCheck } from 'react-lazyload';
import { UitkSpacing } from 'uitk-react-spacing';
import { isRuleApplicable } from './gc-section-data';
import { HeaderMenuLink } from './header-menu-link';
export var HeaderMenu = function (_a) {
    var _b, _c;
    var menu = _a.menu, analytics = _a.analytics, position = _a.position, width = _a.width;
    var _d = __read(React.useState(false), 2), isOpen = _d[0], setIsOpen = _d[1];
    React.useEffect(function () {
        if (isOpen) {
            forceCheck();
        }
    });
    var menuProps = {
        id: menu.id,
        trigger: {
            showText: true,
            showIcon: true,
            text: menu.text,
            icon: menu.iconName,
            iconPosition: menu.iconPosition,
            analytics: analytics === null || analytics === void 0 ? void 0 : analytics.setupTracker(menu.trackingEvent, "Expand ".concat((_b = menu.id) === null || _b === void 0 ? void 0 : _b.toLowerCase(), " dropdown"))
        },
        width: width,
        position: position,
        items: (_c = menu.data) !== null && _c !== void 0 ? _c : [],
        isOpen: isOpen,
        onTriggerClick: function () {
            setIsOpen(!isOpen);
        }
    };
    return (React.createElement(Viewport, null,
        React.createElement(ViewSmall, null,
            React.createElement(ApplicableMenu, __assign({}, menuProps, { trigger: __assign(__assign({}, menuProps.trigger), { showText: isRuleApplicable(menu, 'showText', defaultViewSizes.SMALL) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.SMALL), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.SMALL) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.SMALL) }) }))),
        React.createElement(ViewMedium, null,
            React.createElement(ApplicableMenu, __assign({}, menuProps, { trigger: __assign(__assign({}, menuProps.trigger), { showText: isRuleApplicable(menu, 'showText', defaultViewSizes.MEDIUM) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.MEDIUM), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.MEDIUM) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.MEDIUM) }) }))),
        React.createElement(ViewLarge, null,
            React.createElement(ApplicableMenu, __assign({}, menuProps, { trigger: __assign(__assign({}, menuProps.trigger), { showText: isRuleApplicable(menu, 'showText', defaultViewSizes.LARGE) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.LARGE), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.LARGE) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.LARGE) }) }))),
        React.createElement(ViewExtraLarge, null,
            React.createElement(ApplicableMenu, __assign({}, menuProps, { trigger: __assign(__assign({}, menuProps.trigger), { showText: isRuleApplicable(menu, 'showText', defaultViewSizes.EXTRA_LARGE) && !isRuleApplicable(menu, 'hideText', defaultViewSizes.EXTRA_LARGE), showIcon: isRuleApplicable(menu, 'showIcon', defaultViewSizes.EXTRA_LARGE) && !isRuleApplicable(menu, 'hideIcon', defaultViewSizes.EXTRA_LARGE) }) })))));
};
export var TripsNavigationWrapper = function () { return (React.createElement(UitkSpacing, { margin: { blockend: 'three' } },
    React.createElement("div", null,
        React.createElement(TripsNavigation, null)))); };
export var ApplicableMenu = function (_a) {
    var id = _a.id, trigger = _a.trigger, position = _a.position, width = _a.width, items = _a.items, isOpen = _a.isOpen, onTriggerClick = _a.onTriggerClick;
    var text = trigger.showText ? trigger.text : null;
    var icon = trigger.showIcon ? trigger.icon : null;
    var iconPosition = trigger.iconPosition ? trigger.iconPosition : 'LEFT';
    var buttonSize = text ? UitkButtonSize.MEDIUM : UitkButtonSize.LARGE;
    return (React.createElement(UitkMenu, { id: id, isOpen: isOpen, onTriggerClick: onTriggerClick },
        React.createElement(UitkMenuTrigger, null,
            React.createElement(UitkTertiaryButton, { size: buttonSize, className: "global-navigation-nav-button", analytics: trigger.analytics }, iconPosition === 'RIGHT' ? (React.createElement(React.Fragment, null,
                text && React.createElement(UitkText, { size: 300 }, text),
                icon && React.createElement(UitkIcon, { name: icon }))) : (React.createElement(React.Fragment, null,
                icon && React.createElement(UitkIcon, { name: icon }),
                text && React.createElement(UitkText, { size: 300 }, text))))),
        React.createElement(UitkMenuContainer, { position: position, width: width, autoPosition: true },
            React.createElement("div", { className: "uitk-list" }, !isOpen ? [] : items.map(function (item) {
                switch (item.type) {
                    case 'trips-navigation': return React.createElement(TripsNavigationWrapper, { key: item.id });
                    case 'locale-link': return React.createElement(HeaderMenuLink, { key: item.id, item: item });
                    case 'link': return React.createElement(HeaderMenuLink, { key: item.id, item: item });
                    default: return null;
                }
            })))));
};
//# sourceMappingURL=header-menu.js.map